import React from 'react';
import { Badge, Button, Sym } from '../../../components/app2';
import { formatMxn, formatTierLabel } from '../../../utils/billingService';

/**
 * Tarjeta de plan de la cuadrícula de cambio de plan (rediseño jul-2026).
 *
 * Conserva todo lo que ya distinguía: el plan actual, el recomendado por
 * sobrecupo, los días de prueba, la descripción, la lista de características y
 * el estado de carga del botón.
 */
const PlanCard = ({ plan, isCurrent, isRecommended, onSelect, ctaLabel, loading }) => {
  if (!plan) return null;
  const price = Number(plan.price_mxn);

  const borderColor = isCurrent ? 'var(--brand)'
    : isRecommended ? 'var(--warn)'
    : 'var(--line)';

  return (
    <div
      className="a2-card"
      style={{
        position: 'relative', padding: 20, display: 'flex', flexDirection: 'column',
        height: '100%', borderColor, boxShadow: isCurrent || isRecommended ? `0 0 0 1px ${borderColor}` : undefined,
      }}
    >
      {isCurrent ? (
        <span style={{ position: 'absolute', top: -11, left: 18 }}>
          <Badge tone="brand" icon="check_circle">Tu plan actual</Badge>
        </span>
      ) : isRecommended ? (
        <span style={{ position: 'absolute', top: -11, left: 18 }}>
          <Badge tone="warn" icon="recommend">Recomendado para ti</Badge>
        </span>
      ) : null}

      <h3 style={{ font: "700 1rem 'Hanken Grotesk'", color: 'var(--heading)', margin: 0 }}>{plan.name}</h3>
      <p style={{ font: "500 .78rem 'Hanken Grotesk'", color: 'var(--muted)', margin: '3px 0 0' }}>
        {formatTierLabel(plan)}
      </p>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginTop: 16 }}>
        <span className="a2-serif" style={{ fontSize: '1.9rem', fontWeight: 600, color: 'var(--heading)' }}>
          {formatMxn(price)}
        </span>
        <span style={{ font: "500 .82rem 'Hanken Grotesk'", color: 'var(--muted)' }}>/ mes (IVA inc.)</span>
      </div>

      {Number(plan.trial_days) > 0 ? (
        <span style={{ alignSelf: 'flex-start', marginTop: 10 }}>
          <Badge tone="ok" icon="schedule">{plan.trial_days} días de prueba gratis</Badge>
        </span>
      ) : null}

      {plan.description ? (
        <p style={{ font: "400 .88rem/1.5 'Hanken Grotesk'", color: 'var(--muted)', margin: '14px 0 0' }}>
          {plan.description}
        </p>
      ) : null}

      {Array.isArray(plan.features) && plan.features.length > 0 ? (
        <ul style={{ listStyle: 'none', padding: 0, margin: '16px 0 0', display: 'flex', flexDirection: 'column', gap: 8, flex: 1 }}>
          {plan.features.map((f, idx) => (
            <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, font: "500 .86rem/1.4 'Hanken Grotesk'", color: 'var(--text)' }}>
              <Sym name="check" size={15} style={{ color: 'var(--ok)', flexShrink: 0, marginTop: 2 }} />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      ) : <div style={{ flex: 1 }} />}

      <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid var(--line)' }}>
        <Button
          variant={isRecommended && !isCurrent ? 'primary' : 'outline'}
          disabled={isCurrent || loading}
          loading={loading}
          onClick={onSelect}
          style={{ width: '100%' }}
        >
          {loading ? 'Procesando…' : isCurrent ? 'Tu plan actual' : (ctaLabel || 'Elegir este plan')}
        </Button>
      </div>
    </div>
  );
};

export default PlanCard;
